import { render, staticRenderFns } from "./InventoryExport.vue?vue&type=template&id=3dac8d1a"
import script from "./InventoryExport.vue?vue&type=script&lang=js"
export * from "./InventoryExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports